export default {
    EMPLOYER_SPENDING_REPORTS_READ: "EMPLOYER_SPENDING_REPORTS_READ",

    ORDER_YEAR_REPORTS_READ: "ORDER_YEAR_REPORTS_READ",
};
